module.exports = __webpack_public_path__ + "img/interior_designer_splash.36b36a57.jpg";